export default __webpack_public_path__ + "media/images/email-icon-a5a0b108ad2829df72a93aadfafb46f2.svg";